module.exports = __webpack_public_path__ + "img/xxlj_icon_4.cf0ad25b.svg";